$(function () {
    const toggle = document.querySelector('.header__toggle');
    const nav = document.querySelector('.mobile');
    if (!toggle || !nav) return;

    const sync = () => {
        toggle.setAttribute('aria-expanded', String(nav.classList.contains('mobile--open')));
    };

    sync();
    new MutationObserver(sync).observe(nav, { attributes: true, attributeFilter: ['class'] });
});
